/**
 * Which daily the player has just left, in this visit (QA2-9): Today opens on the next
 * level once yours is solved, except when you've come straight back from it, where the
 * solve and its result are what you're looking at. Module state, never stored: a fresh
 * visit, or any trip through another tab, starts clean.
 */
import type { DateKey } from '@arrow/game-engine';
import type { Level } from '@arrow/puzzle-schema';

let left: { date: DateKey; level: Level } | null = null;

/** A daily's game closed (DailyScreen unmounting). */
export function noteLeftDaily(date: DateKey, level: Level): void {
	left = { date, level };
}

/** The daily the player has just come back from, if it's `date`'s. */
export function leftDaily(date: DateKey): Level | null {
	return left && left.date === date ? left.level : null;
}

/** Spent: Today has shown it (called as Today closes). */
export function forgetLeftDaily(): void {
	left = null;
}
